const OLD_SITE_FALLBACK_URL = "https://www.better2know.co.uk";

const oldSiteByLocale: Record<string, string> = {
  "en-ae": "https://middle-east.better2know.com",
  "en-ie": "https://www.better2know.ie",
  "en-gb": "https://www.better2know.co.uk",
  "en-ke": "https://africa.better2know.com",
};

export function useOldSiteByLocale() {
  const getOldSiteUrl = (localeKey: string): string => {
    const key = localeKey.toLowerCase();
    return oldSiteByLocale[key] ?? OLD_SITE_FALLBACK_URL;
  };

  return {
    oldSiteByLocale,
    oldSiteFallbackUrl: OLD_SITE_FALLBACK_URL,
    getOldSiteUrl,
  };
}
